import {getDealers, getDealersPage} from '../../api/endpoints/dealers'

export const state = {
  currentPage: 1,
  rows: 1,
  perPage: 1,
  data: [],

}

export const getters = {
  tableData: s => s.data,
  currentPage: s => s.currentPage,
  rows: s => s.rows,
  perPage: s => s.perPage
}

export const mutations = {
  GET_ROWS(state) {
    getDealers().then( res => {
      state.rows = res.data.total
    })
  },
  GET_PER_PAGE(state) {
    getDealers().then( res => {
      state.perPage = res.data.per_page
    })
  },
  GET_COUNT(state, id) {
    state.currentPage = id
    getDealersPage(state.currentPage).then( res => {
      state.data = res.data.data
    })
  },
  GET_DATA(state) {
    getDealersPage(state.currentPage).then( res => {
      state.data = res.data.data
    })
  }
}

export const actions = {
  getRows({commit}) {
    commit('GET_ROWS')
  },
  getPerPage({commit}) {
    commit('GET_PER_PAGE')
  },
  getCount({commit}, params) {
    commit('GET_COUNT', params)
  },
  getData({commit}) {
    commit('GET_DATA')
  },
}